import React from 'react'
import { Box, Typography } from '@material-ui/core'
import styled from 'styled-components'
import { useAuth0 } from '../../../contexts/Auth0Context'
import { Button, Header } from '@paro.io/base-ui'
import { IconMail, IconUser } from '@paro.io/base-icons'

export const VerificationBox = styled(Box)`
  background-color: white;
  height: 100vh;
  width: 100%;
  padding-bottom: 100;
`

export const MailLogo = styled.div`
  padding: 20px;
  border: 1px solid #09f8c2;
  border-radius: 3rem;
  margin-bottom: 30px;
`

export const ButtonContainer = styled.button`
  margin-top: 20px;
`

const AccountVerification = (props) => {
  const { loginWithRedirect } = useAuth0()
  const checkRedirection = () => {
    if (props.isFirm) {
      loginWithRedirect({ redirect_uri: process.env.REACT_APP_FIRM_URL })
    } else {
      loginWithRedirect({ redirect_uri: process.env.REACT_APP_FORMSTACK_URL })
    }
  }
  
  return (
    <VerificationBox>
      <div className="md:hidden">
        <Header reverseColor={true} size="sm" />
      </div>
      <div className="hidden md:block">
        <Header reverseColor={true} size="md" />
      </div>
      <Box
        display="flex"
        alignContent="center"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        padding="100px 0px 36px 5px;"
      >
        <MailLogo>
          <IconMail size="lg" className="w-10 h-10" />
        </MailLogo>

        <Typography className="text-center px-4">
          <h3 className="font-bold">Thank you for creating a Paro Expert Account!</h3>
        </Typography>
        <Typography variant="body1" paragraph className="p-4">
          <p className="font-bold">Please sign-in to complete the registration process.</p>
        </Typography>
        <ButtonContainer>
          <Button
            label="Sign In"
            id="signInExpert"
            color="primary"
            iconLeft={<IconUser size="sm" />}
            onClick={() => checkRedirection()}
          />
        </ButtonContainer>
      </Box>
    </VerificationBox>
  )
}

export default AccountVerification
